'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { sdkApi } from '../api.js';

const getOnrampProviders = (_a) => __awaiter(void 0, [_a], void 0, function* ({ chain, environmentId, networkId, token, walletAddress, includeDisabled, }) {
    const { onramps } = yield sdkApi().getSupportedOnramps({
        chain,
        environmentId,
        includeDisabled,
        networkId: networkId ? String(networkId) : undefined,
        token,
        walletAddress,
    });
    return onramps !== null && onramps !== void 0 ? onramps : [];
});

export { getOnrampProviders };
